// client/src/services/accountService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const getAccounts = async () => {
  const response = await fetch(`${apiUrl}/accounts`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des comptes.');
  return await response.json();
};

const createAccount = async (accountData) => {
  const response = await fetch(`${apiUrl}/accounts`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(accountData)
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors de la création du compte.');
  return result;
};

const getBalanceHistory = async (accountId, { from, to } = {}) => {
  const params = new URLSearchParams();
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  const qs = params.toString() ? `?${params.toString()}` : '';
  const response = await fetch(`${apiUrl}/accounts/${accountId}/balance-history${qs}`, {
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) throw new Error("Erreur lors du chargement de l'historique du solde.");
  return await response.json();
};

const getLastImport = async () => {
  const response = await fetch(`${apiUrl}/accounts/last-import`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement du dernier import.');
  return await response.json();
};

const accountService = {
  getAccounts,
  createAccount,
  getBalanceHistory,
  getLastImport
};

export default accountService;
